import { Level, } from "Qrc/lib/manufacturing_state";
export const minReplyStateLevelMap = {
    undefined: {
        undefinedError: Level.fatalError,
    },
    userDefined: {
        undefinedError: Level.fatalError,
    },
    tubeCutting: {
        undefinedError: Level.fatalError,
        undetectedFeatures: Level.warning,
    },
    userDefinedBase: {
        undefinedError: Level.fatalError,
    },
    sheet: {
        undefinedError: Level.fatalError,
        nestingFailed: Level.recoverableError,
    },
    sheetBending: {
        undefinedError: Level.recoverableError,
        undetectedFeatures: Level.warning,
        multipleOuterContours: Level.warning,
        contourInBend: Level.warning,
        invalidBend: Level.fatalError,
    },
    packaging: {
        undefinedError: Level.fatalError,
        insufficientPackageVolume: Level.fatalError,
        overweightParts: Level.fatalError,
    },
    sheetCutting: {
        undefinedError: Level.fatalError,
        undetectedFeatures: Level.warning,
        multipleOuterContours: Level.warning,
        unused0: Level.fatalError,
    },
    joining: {
        undefinedError: Level.fatalError,
    },
    transform: {
        undefinedError: Level.fatalError,
    },
    tube: {
        undefinedError: Level.fatalError,
    },
};
export const minConstraintLevelMap = {
    bendAreasNotOverlapping: Level.warning,
    bendDie: Level.warning,
    bendFlangeTooShort: Level.warning,
    bendThickness: Level.warning,
    contourInBend: Level.warning,
    dataCompleteness: Level.warning,
    dataConsistent: Level.recoverableError,
    dataValidity: Level.recoverableError,
    maxBendLineNetLength: Level.warning,
    maxDimensions: Level.warning,
    maxSheetThickness: Level.warning,
    minContourSize: Level.warning,
    profileSupport: Level.fatalError,
    sheetAvailability: Level.recoverableError,
    sheetMaterialAvailability: Level.recoverableError,
    transportSource: Level.recoverableError,
    tubeAvailability: Level.recoverableError,
    tubeCuttingProcessCompatibility: Level.recoverableError,
    tubeDetectionLicensed: Level.recoverableError,
    tubeNestingAvailability: Level.recoverableError,
    userDefinedProcessId: Level.recoverableError,
};
